import api from './api';

export const getSamsaraTrucksApi = () => api.get('/SamsaraTrucks').then((res) => res.data);

export const getSamsaraGpsCoordinatesApi = () => api.get('/SamsaraGpsData').then((res) => res.data);

export const getSamsaraVehicleDetailsApi = (vehicleId) =>
  api.get(`/GetVehicleDetails?vehicleId=${vehicleId}`).then((res) => res.data);

export const getSamsaraVehicleRoutesApi = (vehicleId) =>
  api.get(`/GetVehicleRoutes?vehicleId=${vehicleId}`).then((res) => res.data);
